import { useFetch } from '../../../hooks/useFetch';
import { Pageable, PageableResponseWrapper, PageQueryParams } from '../../../domain/response-wrapper';
import { usePagination } from '../../../hooks/usePagination';
import { Branch } from '../../../domain/branch';

export interface AuditorBranchesQueryParams extends PageQueryParams {
  idMerchant?: string[];
  idBranch?: string[];
}

const initialParams: AuditorBranchesQueryParams = {
  page: 0,
  size: 5,
  idBranch: [],
  idMerchant: [],
};

export const useAuditorBranchesData = () => {
  const {
    updateParams,
    nextPage,
    queryParams,
    prevPage,
    setParam,
    search
  } = usePagination<AuditorBranchesQueryParams>(initialParams);
  const {
    data,
    loading,
    error,
  } = useFetch<PageableResponseWrapper<Branch>>('/merchants-view/auditor/branches', queryParams);

  return {
    data,
    loading,
    error,
    setParam,
    updateParams,
    nextPage,
    prevPage,
    search,
    queryParams
  };
};
